import useEnhancedEffect from "@mui/material/utils/useEnhancedEffect";
import { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import isEmpty from "lodash/isEmpty";
import { useAppDispatch, useAppSelector } from "@/sharedStore/hooks";
import { useCheckRole } from "@/providers/auth/hooks";
import { AccessDeniedPage } from "@/components";
import { ROLE } from "@/configuration/globalVariable";
import { userSelector } from "@/providers/auth/selector";
import {
  fetchDeliverySettings,
  fetchStorageAddressAsync,
} from "./providers/deliveryManifest/sliceServices";
import {
  deliverySettingsLoadedSelector,
  deliverySettingsSelector,
} from "./providers/deliveryManifest/selector";
import { clearManifest } from "./providers/deliveryManifest/slice";

const Index = () => {
  const [date, setDate] = useState<Date | null>(null);
  const dispatch = useAppDispatch();
  const user = useAppSelector(userSelector);

  const deliverySettings = useAppSelector(deliverySettingsSelector);
  const isDeliverySettingsLoaded = useAppSelector(
    deliverySettingsLoadedSelector
  );

  const checkRole = useCheckRole();

  useEnhancedEffect(() => {
    dispatch(clearManifest());
    dispatch(fetchDeliverySettings());
    dispatch(fetchStorageAddressAsync());
  }, []);

  useEffect(() => {
    if (isDeliverySettingsLoaded) {
      const deliveryDate = new Date();
      if (deliverySettings?.deliveryDefaultDate === 1) {
        deliveryDate.setDate(deliveryDate.getDate() + 1);
      }
      setDate(deliveryDate);
    } else {
      setDate(null);
    }
  }, [deliverySettings, isDeliverySettingsLoaded]);

  const checkPermission = checkRole(ROLE.ADMIN);

  return checkPermission ? (
    date && <Outlet context={[date, setDate]} />
  ) : (
    <>{!isEmpty(user) && <AccessDeniedPage />}</>
  );
};

export default Index;
